export function documentTypeLabel(
  type: string | null,
  t: (key: string, options?: Record<string, unknown>) => string,
): string {
  if (!type) return '—'
  const key = `docTypes.${type}`
  const translated = t(key)
  return translated === key ? humanizeSlug(type) : translated
}

function humanizeSlug(value: string): string {
  return value
    .replace(/[_.]+/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1)}`)
    .join(' ')
}
